import {Vue, Component} from 'vue-property-decorator'
@Component
export default class Freeproducts extends Vue {
   

    down(){
        this.$emit('down');
    }
}

